import script from "./TheFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFooter.vue?vue&type=script&setup=true&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=6660f662&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6660f662"]])

export default __exports__